import StarIcon from "@mui/icons-material/StarRounded";
import StarBorderIcon from "@mui/icons-material/StarBorderRounded";
import { Tooltip } from "@mui/material";
import { amber } from "@mui/material/colors";

interface Props {
  isFavorite: boolean;
  readonlyMode?: boolean;
}

const FavoriteStarIcon = ({ isFavorite, readonlyMode }: Props) => {
  return (
    <Tooltip
      title={isFavorite ? "Remove from favorites" : "Add to favorites"}
      enterDelay={500}
      enterNextDelay={500}
      arrow
      disableInteractive
    >
      {isFavorite ? (
        <StarIcon sx={{ color: amber[600], opacity: readonlyMode ? 0.5 : 1 }} />
      ) : (
        <StarBorderIcon
          sx={{ color: "secondary.main", ":hover": { color: amber[600] }, opacity: readonlyMode ? 0.5 : 1 }}
        />
      )}
    </Tooltip>
  );
};

export default FavoriteStarIcon;
